let hamburger = document.querySelector('button.hamburger');

if (hamburger && window.getComputedStyle(hamburger).getPropertyValue('display') !== 'none') {
  hamburger.addEventListener('click', function() {
    document.querySelector('nav.main').classList.toggle('open');
  });

  document.querySelector('nav.main').addEventListener('click', (evt) => {
    let el = evt.target.closest('li');

    if (el.classList.contains('menuHasChild')) {
      evt.preventDefault();
      el.classList.toggle('menuOpen');
    }
  })
}
